
var percentNumberFormatter = new Intl.NumberFormat(
  undefined,
  { style: 'decimal', signDisplay: 'always', maximumFractionDigits: 2 }
);

var percentNumberFormatterNoSign = new Intl.NumberFormat(
  undefined,
  { style: 'decimal', signDisplay: 'never', maximumFractionDigits: 2 }
);


var currencyFormatter;
var currencyFormatterNoDecimals;

try {
  currencyFormatter = new Intl.NumberFormat(
    undefined,
    { style: 'currency', currency: 'USD', currencyDisplay: 'narrowSymbol', trailingZeroDisplay: 'lessPrecision' }
  );
  currencyFormatterNoDecimals = new Intl.NumberFormat(
    undefined,
    { style: 'currency', currency: 'USD', currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: 0 }
  );
} catch (err) {
  // Safari iPhone doesn't always like the above, we try a more basic version
  currencyFormatter = new Intl.NumberFormat(
    'en',
    { style: 'currency', currency: 'USD' }
  );
  currencyFormatterNoDecimals = new Intl.NumberFormat(
    'en',
    { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }
  );
}


export { currencyFormatter, currencyFormatterNoDecimals, percentNumberFormatter, percentNumberFormatterNoSign };

